import { BASE_URL, WORKSHOP, WORKSHOP_ASSESSMENTS } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IWorkshopAssessmentsInput } from "models/workshopAssessments";


export async function getWorkshopAssessments(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOP_ASSESSMENTS + params);
  return response.data;
}

export async function getAssessmentQuestions(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOP_ASSESSMENTS + params);
  return response.data;
}

export async function addWorkshopAssessments(data: IWorkshopAssessmentsInput) {
  const response = await axios.post(BASE_URL + WORKSHOP_ASSESSMENTS, data);
  return response.data;
}

export async function changeEnrollmentStatus(data: {id:string;status:number}) {
  const response = await axios.post(BASE_URL + WORKSHOP + '/update-enrollment-statuses', {
  "updates": [
    data
  ]
} );
  return response.data;
}

export async function notifyAttendees(data: string) {
  const response = await axios.get(
    BASE_URL + WORKSHOP_ASSESSMENTS + '/notifyattendees',
    { params: { workshopId: data } } 
  );
  return response.data;
}

export async function editWorkshopAssessments(data: IWorkshopAssessmentsInput, id: string) {
  const response = await axios.patch(BASE_URL + WORKSHOP_ASSESSMENTS + "/" + id, data);
  return response.data;
}

export async function deleteWorkshopAssessments(id: string) {
  const response = await axios.delete(BASE_URL + WORKSHOP_ASSESSMENTS + "/" + id);
  return response.data;
}

export async function getAssessmentProgress(params: string = "") {
  const response = await axios.get(BASE_URL + WORKSHOP_ASSESSMENTS + '/getassessmentprogress' + params);
  return response.data;
}

export async function getEmployeesWithVouchers(workshopAssessmentId: string) {
  const response = await axios.get(BASE_URL + WORKSHOP_ASSESSMENTS + '/getemployeeswithvouchers?workshopAssessmentId=' + workshopAssessmentId);
  return response.data;
}

export async function createVouchersForEmployees(workshopAssessmentId: string, employeeVouchers: Array<{ employeeId: string; discount: number }>) {
  const response = await axios.post(BASE_URL + WORKSHOP_ASSESSMENTS + '/createvouchers', {
    workshopAssessmentId: workshopAssessmentId,
    employeeVouchers: employeeVouchers.map(ev => ({
      employeeId: ev.employeeId,
      discount: ev.discount
    }))
  });
  return response.data;
}


export const WorkshopAssessmentsCells: HeadCell[] = [

  {
    id: "assessmentDefinitionTitle",
    numeric: false,
    disablePadding: false,
    label: "T_title",
  },
  {
    id: "timeToComplete",
    numeric: true,
    disablePadding: false,
    label: "T_time_to_complete",
  },
  {
    id: "active",
    numeric: false,
    disablePadding: false,
    label: "T_active",
  },
  {
    id: "typeName",
    numeric: false,
    disablePadding: false,
    label: "T_type",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];

export const WorkshopAssessmentsCellsExtra: HeadCell[] = [

  {
    id: "assessmentDefinitionTitle",
    numeric: false,
    disablePadding: false,
    label: "T_title",
  },
  {
    id: "timeToComplete",
    numeric: true,
    disablePadding: false,
    label: "T_time_to_complete",
  },
  {
    id: "active",
    numeric: false,
    disablePadding: false,
    label: "T_active",
  },
  {
    id: "typeName",
    numeric: false,
    disablePadding: false,
    label: "T_type",
  },
  {
    id: "numberOfEnrollments",
    numeric: false,
    disablePadding: false,
    label: "T_number_enrollments",
  },
  {
    id: "pretestCount",
    numeric: false,
    disablePadding: false,
    label: "pre",
  },
  {
    id: "posttestCount",
    numeric: false,
    disablePadding: false,
    label: "post",
  },
  {
    id: "numberOfEvaluations",
    numeric: false,
    disablePadding: false,
    label: "eval",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];